import theme from "../../themes/green";

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    backgroundColor: theme.pallete.background,
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },
  forgotPasswordWrapper: {
    textAlign: "right"
  },
  forgotPassword: {
    fontSize: 9
  },
  logo: {
    margin: 20
  },
  socialLogin: {
    color: theme.pallete.background
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/containers/Login/styles.js